import _axios from '@/util/httpConfig.js'

export const getLinkList = (moduleCode, typeCode, pageSize = 6) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "pageNo": 1,
    "pageSize": 999,
    "tenantCode": "96F307B9D0EDF9F",
  }
  return _axios('POST', '/common-content/website/list','' ,data)
}


// WEBPACK FOOTER //
// ./src/api/footer.js